import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { logger } from './logger';

const firebaseConfig = {
  apiKey: process.env.EXPO_PUBLIC_API_KEY ?? null,
  authDomain: process.env.EXPO_PUBLIC_AUTH_DOMAIN ?? null,
  projectId: process.env.EXPO_PUBLIC_PROJECT_ID ?? null,
  storageBucket: process.env.EXPO_PUBLIC_STORAGE_BUCKET ?? null,
  messagingSenderId: process.env.EXPO_PUBLIC_MESSAGING_SENDER_ID ?? null,
  appId: process.env.EXPO_PUBLIC_APP_ID ?? null,
};

const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.storageBucket &&
    firebaseConfig.messagingSenderId &&
    firebaseConfig.appId
);

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;

// Garante que a inicialização ocorra apenas uma vez
if (!isFirebaseConfigured) {
  logger.warn('Firebase: Missing EXPO_PUBLIC_* env vars. Skipping Firebase initialization for this build.');
} else {
  if (!getApps().length) {
    logger.debug('Firebase: Initializing new instance');
    app = initializeApp(firebaseConfig as any);
  } else {
    logger.debug('Firebase: Reusing existing instance');
    app = getApps()[0];
  }

  auth = getAuth(app);
  db = getFirestore(app);
}

export { app, auth, db, isFirebaseConfigured };

if (isFirebaseConfigured) {
  logger.debug('Firebase: Instances ready and exported');
}
